export default "__VITE_ASSET__CtRl9PgS__"